// extracted by mini-css-extract-plugin
export default {"section":"Industries_section__pFSLK","head":"Industries_head__-jG4u","pills":"Industries_pills__Fbt2-","pill":"Industries_pill__XyDB0"};